import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';

import { BackButton } from './BackButton';
import { IContainer } from './interfaces';

export const Container: React.FC<IContainer> = ({
  isSuccess,
  colorBackButton,
  id,
  ...rest
}) => {
  const [urlBack, setUrlBack] = useState<string>();
  const { goBack, push } = useHistory();

  const onBack = () => {
    if (urlBack) {
      push(urlBack);
    } else {
      goBack();
    }
  };

  useEffect(() => {
    const params = new URL(window.location as any).searchParams;

    const href: any = params.get('href');
    if (href) setUrlBack(href);
    if (window.location.pathname === '/onboarding' && !href) setUrlBack('/');

    window.addEventListener('popstate', onBack);
    return () => window.removeEventListener('popstate', onBack);
  }, [window.location, window.location.search]);

  return (
    <BackButton
      isSuccess={isSuccess}
      colorBackButton={colorBackButton}
      {...rest}
      id={`backButton@${id}`}
      data-testid={`backButton@${id}`}
      onClick={onBack}
    />
  );
};

export default Container;
